/**
 * Domain enums. These mirror the Prisma enums one-to-one — when you change one,
 * change the other in the same commit.
 */
export const USER_ROLES = ['ADMIN', 'ACCOUNTANT', 'SITE_MANAGER'];
export const VENDOR_TYPES = ['SUPPLIER', 'SUBCONTRACTOR', 'OTHER'];
export const INVOICE_SOURCES = ['MANUAL', 'KSEF', 'EMAIL'];
/**
 * Invoice lifecycle. Allowed transitions live in `invoice-transitions.ts` —
 * this array only declares the states themselves.
 */
export const INVOICE_STATUSES = [
    'NEW',
    'ASSIGNED',
    'APPROVED_BY_MANAGER',
    'DISPUTED',
    'APPROVED_FOR_PAYMENT',
    'PAID',
];
/**
 * How the invoice is settled.
 *
 * A cash invoice is paid at the counter, so it is never something the company
 * still owes — it is the reason `payables` may drop a row entirely rather than
 * merely mark it.
 */
export const PAYMENT_METHODS = ['TRANSFER', 'CASH'];
/**
 * Why an invoice is settled for a different amount than its gross.
 * `RETENTION` is the warranty holdback on subcontractor work; the rest arrive
 * later as documents (a correcting invoice) or as terms (an early-payment discount).
 */
export const ADJUSTMENT_KINDS = ['RETENTION', 'CORRECTION', 'DISCOUNT', 'OTHER'];
/**
 * Delivery state of a message the app sends.
 *
 * Mail leaves through an outbox table and a worker, so "sent" happens after
 * the request that asked for it. An order *is* a message, so this doubles as
 * the order's own status — see `order.schema.ts`.
 */
export const MAIL_STATUSES = ['PENDING', 'SENT', 'FAILED'];
/**
 * Fixed reasons a site manager can pick when rejecting an invoice.
 * A free-text box alone produces "not mine" with no context and a phone call
 * to the accountant five minutes later.
 */
export const DISPUTE_REASONS = [
    'WRONG_PROJECT',
    'QUANTITY_MISMATCH',
    'PRICE_MISMATCH',
    'NOT_DELIVERED',
    'OTHER',
];
//# sourceMappingURL=enums.js.map